import './sass/login.sass';
import { showHidePasswordInput } from "./components/show-hide-password-input";

const backBtn = document.getElementById('back-button');

showHidePasswordInput(document.querySelectorAll('.login__field-input-toggle-button'));

backBtn?.addEventListener('click', () => {
    window.history.back();
});
